/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CancelOperationFailureDto } from './CancelOperationFailureDto';
import {
    CancelOperationFailureDtoFromJSON,
    CancelOperationFailureDtoFromJSONTyped,
    CancelOperationFailureDtoToJSON,
    CancelOperationFailureDtoToJSONTyped,
} from './CancelOperationFailureDto';

/**
 * 
 * @export
 * @interface CancelOperationResponseDto
 */
export interface CancelOperationResponseDto {
    /**
     * Successfully canceled patient IDs
     * @type {Array<string>}
     * @memberof CancelOperationResponseDto
     */
    success: Array<string>;
    /**
     * Failed operations
     * @type {Array<CancelOperationFailureDto>}
     * @memberof CancelOperationResponseDto
     */
    failed: Array<CancelOperationFailureDto>;
}

/**
 * Check if a given object implements the CancelOperationResponseDto interface.
 */
export function instanceOfCancelOperationResponseDto(value: object): value is CancelOperationResponseDto {
    if (!('success' in value) || value['success'] === undefined) return false;
    if (!('failed' in value) || value['failed'] === undefined) return false;
    return true;
}

export function CancelOperationResponseDtoFromJSON(json: any): CancelOperationResponseDto {
    return CancelOperationResponseDtoFromJSONTyped(json, false);
}

export function CancelOperationResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CancelOperationResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
        'failed': ((json['failed'] as Array<any>).map(CancelOperationFailureDtoFromJSON)),
    };
}

export function CancelOperationResponseDtoToJSON(json: any): CancelOperationResponseDto {
    return CancelOperationResponseDtoToJSONTyped(json, false);
}

export function CancelOperationResponseDtoToJSONTyped(value?: CancelOperationResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'failed': ((value['failed'] as Array<any>).map(CancelOperationFailureDtoToJSON)),
    };
}

